module.exports = __webpack_public_path__ + "static/media/AoA_RaceGameEnvShot_03.87a96d19.jpg";